<template>
	<div class="p_box" id="box">
		<el-breadcrumb separator="/" id="head">
			<el-breadcrumb-item :to="{ path: '/Homet' }" replace>首页</el-breadcrumb-item>
			<el-breadcrumb-item :to="{ path: '/Mine' }" replace>我的题库</el-breadcrumb-item>
			<el-breadcrumb-item>修改习题</el-breadcrumb-item>
		</el-breadcrumb>
		<div class="sinle_box p_m_t_30 ">
			<div class="sinle_head" id="header"><single-header :postData='postData'  :gradeType="postData.grade" :subjectType="postData.subject" @questionTypes="questionTypes"></single-header></div>
		</div>
		<div class="sinle_box overflow" :style="{ height: height + 'px' }">
			<div class="sinle_center">
				<!-- 单选 -->
				<single-choice ref="choice" :topicContent="postData" v-if="obj == 1"></single-choice>
				<!-- 多选 -->
				<single-multiple ref="multiple" :topicContent="postData" v-if="obj == 2"></single-multiple>
				<!-- 判断 -->
				<single-judge ref="judge" :topicContent="postData" v-if="obj == 3"></single-judge>
				<!-- 填空 -->
				<single-filling ref="filling" :topicContent="postData" v-if="obj == 4"></single-filling>
				<!-- 问答 -->
				<single-answers ref="answers" :topicContent="postData" v-if="obj == 5"></single-answers>
				<!-- 材料 -->
				<single-materials ref="materials" :topicContent="postData" v-if="obj == 6"></single-materials>
				<div class="p_flex p_m_t_30">
					<div class="xuan type_size_22 p_flex p_f_e">解析</div>
					<div class="choice_input p_m_l_30"><el-input type="textarea" :autosize="{ minRows: 2 }" placeholder="请输入内容" v-model="postData.analysis"></el-input></div>
				</div>
				<!-- <div class="p_flex p_m_t_30 p_f_c">
					<div @click="goContinue(0)"><el-button type="success">继续录入</el-button></div>
					<div class="p_m_l_60" @click="goComplete"><el-button type="primary">完成录入</el-button></div>
				</div> -->
				<div class="p_flex p_m_t_30 p_f_c">
					<div  @click="goSave"><el-button type="success">保存</el-button></div>
				</div>
			</div>
		</div>
		<el-dialog title="习题册名称" center :visible="dialogVisible" @close="close">
			<el-input type="textarea" :rows="2" placeholder="请输入内容" :autosize="{ minRows: 4, maxRows: 99 }" v-model="createData.exerciseBook"></el-input>
			<div class="header_center p_flex p_f_a  p_m_t_20 ">
				<span class="p_m_l_20 type_size_18">年级</span>
				<div class="p_f_1 p_m_l_20 p_m_r_20">
					<el-select v-model="postData.grade" placeholder="选择年级" @change="gradeType">
						<el-option v-for="item in gradeLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
			</div>
			<div class="header_center p_flex p_f_a p_m_t_20 ">
				<span class="p_m_l_20 type_size_18">学科</span>
				<div class="p_f_1 p_m_l_20 p_m_r_20">
					<el-select v-model="postData.subject" placeholder="选择学科" @change="gradeType">
						<el-option v-for="item in subjectLists" :key="item.id" :label="item.name" :value="item.id"></el-option>
					</el-select>
				</div>
			</div>
			<div class="p_flex p_f_c p_m_t_30"><el-button @click.stop="goConfirm" type="success">确认</el-button></div>
		</el-dialog>
	</div>
</template>

<script>
// 头部内容
import SingleHeader from '../commponents/singleHeader.vue';
// 单选
import SingleChoice from '../commponents/singleChoice.vue';
// 多选
import SingleMultiple from '../commponents/singleMultiple.vue';
// 判断
import SingleJudge from '../commponents/singleJudge.vue';
// 填空
import SingleFilling from '../commponents/singleFilling.vue';
// 问答
import SingleAnswers from '../commponents/singleAnswers.vue';
// 材料题
import SingleMaterials from '../commponents/singleMaterials.vue';
export default {
	name: 'Reviseexercises',
	components: {
		SingleHeader,
		SingleChoice,
		SingleMultiple,
		SingleJudge,
		SingleFilling,
		SingleAnswers,
		SingleMaterials
	},
	data() {
		return {
			// 解析
			analysis: '',
			// 1为多题,2为习题
			type: 1,
			// 习题册弹框
			dialogVisible: false,

			obj: 1,
			height: 0,
			postData: { question_type: '1', title: '', affiliation: [], analysis: '', grade: '', subject: '', type: '', year: '', score: '' },
			title: '',
			createData: {
				gradeTypes: '',
				subjectTypes: '',
				// 习题册名称
				exerciseBook: ''
			},
			gradeLists: [],
			subjectLists: [],
			question_ids:[],
			id:''
		};
	},
	watch: {
		'$route.path': {
			immediate: true,
			handler(newVal, oldVal) {
				if (newVal == '/Reviseexercises') {
					var height = localStorage.getItem('height');
					if (height == '') {
					} else {
						this.height = height;
					}
				}
			}
		}
	},
	created() {
		this.$request
			.ajax(this)
			.post('/Library/grade')
			.then(res => {
				// console.log(res.data)
				this.gradeLists = res.data;
			});
		this.$request
			.ajax(this)
			.post('/Library/subject')
			.then(res => {
				// console.log(res.data)
				this.subjectLists = res.data;
			});
	},
	beforeRouteLeave(to, form, next) {
		localStorage.removeItem('height');
		next();
	},
	mounted() {
		this.type = this.$route.query.type;
		if (this.type == 1) {
			this.dialogVisible = true;
		} else {
			this.dialogVisible = false;
		}
		var id = this.$route.query.id;
		this.id = id
		if( this.type == 2 ){
			this.$request.ajax(this).post('/api_teacher/question_detail/' + id).then(res=>{
				this.obj = res.data.question_type
				this.postData.analysis = res.data.analysis
				this.postData = res.data
				console.log(this.postData)
			})
		}

		this.indexInfo();
	},
	methods: {
		indexInfo() {
			var box = document.getElementById('box').offsetHeight;
			var head = document.getElementById('head').offsetHeight;
			var header = document.getElementById('header').offsetHeight;
			var height = box - head - header - 30;
			var heights = localStorage.getItem('height');
			if (heights == null) {
				localStorage.setItem('height', height);
			} else {
			}
			this.height = height;
		},
		goContinue(i) {
			const that = this;
			var info = that.postData;
			if (info.question_type == '') {
				that.$message.error('请选择题型');
				return;
			}
			if (info.grade == '') {
				that.$message.error('请选择年级');
				return;
			}
			if (info.subject == '') {
				that.$message.error('请选择学科');
				return;
			}
			if (info.type == '') {
				that.$message.error('请选择类型');
				return;
			}
			if (info.year == '') {
				that.$message.error('请选择年份');
				return;
			}
			if (info.score == '') {
				that.$message.error('请输入题目分数');
				return;
			}
			if (info.title == '') {
				that.$message.error('请输入题目');
				return;
			}
			// console.log(that.postData);
			that.questionInfo(0);
		},
		questionTypes(info) {
			this.obj = info.questionTypes;
			this.postData.question_type = info.questionTypes;
			this.postData.grade = info.gradeTypes;
			this.postData.subject = info.subjectTypes;
			this.postData.type = info.genreTypes;
			this.postData.year = info.yearTypes;
			this.postData.score = info.pointTypes;
		},
		questionInfo(i) {
			this.$request
				.ajax(this)
				.post('/api_teacher/question_create', this.postData)
				.then(res => {
					console.log(res);
					this.question_ids.push(res.data.id)
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.postData.title = '';
					this.postData.analysis = '';
					if (i == 1) {
						this.$router.push({
							path: '/Select'
						});
					}
				});
		},
		// 完成
		goComplete() {
			const thta = this;
			if (thta.type == 1) {
				// thta.dialogVisible = true;
				this.createInfo()
			} else {
				thta.goContinue(1);
			}
		},
		// 新建习题册
		createInfo(){
			const that = this
			const data = {}
			data.name = that.createData.exerciseBook
			data.grade = that.postData.grade
			data.subject = that.postData.subject
			data.question_ids = that.question_ids
			this.$request
				.ajax(this)
				.post('/api_teacher/exercise_book_create', data)
				.then(res => {
					this.$message({
						message: res.msg,
						type: 'success'
					});
					this.$router.go(-1); //返回上一层
				});
		},
		// 确认
		goConfirm() {
			const that = this;
			if (that.createData.exerciseBook == '') {
				that.$message.error('请输入名称');
				return;
			}
			var info = that.postData;
			if (info.grade == '') {
				that.$message.error('请选择年级');
				return;
			}
			if (info.subject == '') {
				that.$message.error('请选择学科');
				return;
			}
			that.dialogVisible = false;
		},
		// 修改保存
		goSave(){
			this.$request.ajax(this).post('/api_teacher/question_edit/' + this.id,this.postData).then(res=>{
				// this.$message.success(res.msg);
				this.$router.go(-1);
			})
		},
		// 选择年级
		gradeType(e) {},
		// 关闭按钮
		close() {
			if (this.type == 1) {
				if (this.createData.exerciseBook == '') {
					this.$router.go(-1); //返回上一层
				} else {
					this.dialogVisible = false;
				}
			}
		}
	}
};
</script>

<style lang="scss" scoped>
.sinle_box {
	// padding: 30px 60px;
	background: #ffffff;
	// border-radius: 10px 10px 0px 0px;
}

.sinle_head {
	margin: 0 60px;
	padding: 30px 0;
}
.sinle_center {
	margin: 0 60px;
	padding-bottom: 30px;
}
.choice_input {
	width: 840px;
}
>>> .el-textarea__inner {
	border: none;
	background-color: #f5f5f5;
	font-size: 18;
}
>>> textarea::-webkit-input-placeholder {
	font-size: 18px;
}
.xuan {
	width: 88px;
}
.header_center {
	height: 65px;
	background: #f5f5f5;
	border-radius: 10px;
}
>>> .el-input__inner {
	border: none;
	background: #f5f5f5;
	font-size: 18px;
}
>>> .el-select {
	width: 100%;
}
>>> input::-webkit-input-placeholder {
	font-size: 18px;
}
>>> .el-select .el-input .el-select__caret {
	font-size: 18px;
	color: #000000;
}
</style>



// WEBPACK FOOTER //
// src/components/homet/reviseexercises/Reviseexercises.vue